import { z } from "zod";
import { moment } from "../../date";

export const ZodDateString = z.preprocess(
	(val) => {
		if (typeof val === "number") {
			const timestamp = val;
			const date = moment(new Date(timestamp));
			return date.db();
		}
		return val;
	},
	z.string().regex(/^\d{4}-\d{2}-\d{2}$/, {
		message: "Invalid date format. Expected YYYY-MM-DD.",
	}),
) as unknown as z.ZodString;
